import { Box, Button, Divider, Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { AddManualZircuitNetworkModal } from 'components/AddManualZircuitNetworkModal'
import { Announcement } from 'components/Announcement'
import { CopyToClipboardButton } from 'components/CopyToClipboardButton'
import { Modal } from 'components/Modal'
import { FULL_ZIRCUIT_NETWORK_NAME } from 'constants/common'
import { zircuit } from 'constants/network'
import { env } from 'env.client'
import { useThemeColors } from 'hooks/useThemeColors'
import { useToast } from 'hooks/useToast'

const RPC_URL =
  ['mainnet', 'testnet'].includes(env.NEXT_PUBLIC_NETWORK) && zircuit.rpcUrls.default.http[0]

export const UpdatedRpcModalAnnouncement = () => {
  const COLORS = useThemeColors()
  const toast = useToast()
  const [isAddUpdatedRpcModalOpen, setIsAddUpdatedRpcModalOpen] = React.useState<boolean>(false)
  const [isAddManualNetworkOpen, setIsAddManualNetworkOpen] = React.useState<boolean>(false)

  const handleAddToMetamask = React.useCallback(async () => {
    try {
      await window.ethereum?.request?.({
        method: 'wallet_addEthereumChain',
        params: [
          {
            chainId: `0X${zircuit.id.toString(16)}`,
            rpcUrls: zircuit.rpcUrls.default.http,
            chainName: FULL_ZIRCUIT_NETWORK_NAME,
            nativeCurrency: zircuit.nativeCurrency,
            blockExplorerUrls: [env.NEXT_PUBLIC_BLOCK_EXPLORER_URL],
          },
        ],
      })
      setIsAddUpdatedRpcModalOpen(false)
      toast({ message: 'Zircuit network added', status: 'success' })
    } catch (error) {
      // *: User rejected the request
      if (typeof error === 'object' && error !== null && 'code' in error && error.code === 4001) {
        return
      }

      setIsAddUpdatedRpcModalOpen(false)
      setIsAddManualNetworkOpen(true)
    }
  }, [toast])

  React.useEffect(() => {
    const hasModalBeenShown = localStorage.getItem('updatedRpcModalShown')

    if (!hasModalBeenShown) {
      setIsAddUpdatedRpcModalOpen(true)
      localStorage.setItem('updatedRpcModalShown', 'true')
    }
  }, [])

  if (!RPC_URL) {
    return null
  }

  return (
    <>
      <Modal
        variant="infoZircuit"
        isOpen={isAddUpdatedRpcModalOpen}
        onClose={() => {
          setIsAddUpdatedRpcModalOpen(false)
        }}
        title="Update your default RPC url"
        customFooter={<Button onClick={handleAddToMetamask}>Add to Metamask</Button>}
      >
        <Text variant="text3regular" mb={6}>
          {`Default RPC url for ${FULL_ZIRCUIT_NETWORK_NAME} has been updated, please update it within your wallet with following:`}
        </Text>
        <Flex alignItems="center" justifyContent="space-between" gap={2}>
          <Box>
            <Text variant="text3medium">RPC url</Text>
            <Text variant="text3regular">{RPC_URL}</Text>
          </Box>
          <CopyToClipboardButton text={RPC_URL} />
        </Flex>
        <Divider />
      </Modal>
      <AddManualZircuitNetworkModal
        isOpen={isAddManualNetworkOpen}
        onClose={() => {
          setIsAddManualNetworkOpen(false)
        }}
      />
      <Announcement>
        <Flex gap={1} wrap="wrap">
          <Text>{`${FULL_ZIRCUIT_NETWORK_NAME} default RPC url has been updated to`}</Text>
          <Text color={COLORS.zircuitDark} variant="text1medium">
            {RPC_URL}
          </Text>
          <CopyToClipboardButton text={RPC_URL} iconColor={COLORS.zircuitDark} />
        </Flex>
      </Announcement>
    </>
  )
}
